import templateUrl from "emun.cart/cart-item-quick-view-personalize.htm";

export default () => ({
  templateUrl
});
